<section id="about" class="box-white box-custom-border box-custom-border-10">
    <div class="grid-list">
        <div class="row margin-none">
            <div class="wrapper padding-all">
                <h1 class="line-bottom left">Milestone</h1>
                <div class="grid col-md-12 col-sm-12">
                    <img src="assets/img/milestone.png" width="100%">
                </div>
            </div>
        </div>
    </div>
</section>
